const state = {};
const getters = {};
import moment from 'moment';

const actions = {
    // Notification - Templates
    async getItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/notification-templates`, {
                    method: "GET",
                    params: params
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
    async getItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/notification-templates/${params}`, {
                    method: "GET"
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
    async saveItemLMU({ commit }, params) {
        return new Promise((resolve, reject) => {

            let formData = new FormData();
            formData.append('id', params.id);
            formData.append('title', params.title);
            formData.append('content', params.content);
            formData.append('medium', params.medium);
            formData.append('event_trigger_id', params.event_trigger_id);
            formData.append('module_use', params.module_use);
            formData.append('contract_id', params.contract_id);
            formData.append('active', params.active);

            let to_recipient = null
            let cc_recipient = null
            let bcc_recipient = null

            if ( params.recipient[0] ) {
                delete params.recipient[0].title;
                to_recipient = JSON.stringify(params.recipient[0])
            }

            if ( params.recipient[1] ) {
                delete params.recipient[1].title;
                cc_recipient = JSON.stringify(params.recipient[1])
            }

            if ( params.recipient[2] ) {
                delete params.recipient[2].title;
                bcc_recipient = JSON.stringify(params.recipient[2])
            }

            if ( to_recipient && to_recipient !== '{}' ) {
                formData.append('to_recipient', to_recipient);
            }
            
            if ( cc_recipient && cc_recipient !== '{}' ) {
                formData.append('cc_recipient', cc_recipient);
            }
            
            if ( bcc_recipient && bcc_recipient !== '{}' ) {
                formData.append('bcc_recipient', bcc_recipient);
            }
            
            if ( params.is_repeat ) {
                formData.append('is_repeat', params.is_repeat);
            }
            
            formData.append('repeat_hours', params.repeat_hours || '');
            formData.append('repeat_end_times', params.repeat_end_times || '');
            formData.append('repeat_end_datetime', params.repeat_end_datetime ? moment(params.repeat_end_datetime).format("YYYY-MM-DD") : '');
            
            for(let i = 0; i < params.attachments.length; i++){
                formData.append(`files[${i}]`, params.attachments[i]);
            }
            
            global.axios(`/api/notification-templates/${params.id}`, {
                method: "POST",
                headers: {
                  Accept: "application/json",
                },
                data : formData
            })
            .then(response => {
                resolve(response.data.data)
            })
            .catch(error => {
                reject(error);
            })
        });
    },
    async saveItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/notification-templates/${params.id}`, {
                    method: "POST",
                    data: params
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },

    async deleteItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/notification-templates`, {
                    data: {
                        ids: params
                    }
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async cloneTemplate({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/notification-templates/clone`, {
                    method: "POST",
                    data: params
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
    // Notification - Event Trigger
    async getEventsTrigger({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/notification-event-trigger`, {
                    method: "GET",
                    params: params
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
    // Notification - Params
    async getParameter({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/notification-parameter`, {
                    method: "GET",
                    params: params
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error);
                })
        });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}